import i18n from '../i18n'

const referentialLocaleMessage = {
  mergeLocalMessage(referential) {
    for (const family in referential._source) {
      if (!family) {
        continue
      }

      for (const subFamily in referential._source[family].subFamilies) {
        if (!subFamily) {
          continue
        }

        for (const attribute of referential._source[family].subFamilies[
          subFamily
        ].attributes) {
          if (!attribute.i18n) {
            continue
          }

          for (const locale in attribute.i18n) {
            if (!locale) {
              continue
            }

            i18n.mergeLocaleMessage(locale, {
              [`${family}-${subFamily}-${attribute.name}`]:
                attribute.i18n[locale],
            })
          }
        }
      }
    }
  },
}

export default referentialLocaleMessage
